import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/firmNameActions';
import { firmNamesAPI } from '../../api/config';

// Fetch all firm names
function* fetchFirmNamesSaga(action) {
  try {
    const response = yield call(firmNamesAPI.fetchFirmNames, action.payload);
    // API returns { firm_names: [], total_count: n }
    yield put(actions.fetchFirmNamesSuccess({
      data: response.data.firm_names || [],
      total: response.data.total_count || 0
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Failed to fetch firm names';
    yield put(actions.fetchFirmNamesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Fetch active firm names
function* fetchActiveFirmNamesSaga() {
  try {
    const response = yield call(firmNamesAPI.fetchActiveFirmNames);
    // API returns { firm_names: [], total_count: n }
    yield put(actions.fetchActiveFirmNamesSuccess({
      data: response.data.firm_names || [],
      total: response.data.total_count || 0
    }));
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Failed to fetch active firm names';
    yield put(actions.fetchActiveFirmNamesFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Get single firm name
function* getFirmNameSaga(action) {
  try {
    const response = yield call(firmNamesAPI.getFirmName, action.payload);
    yield put(actions.getFirmNameSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Failed to fetch firm name';
    yield put(actions.getFirmNameFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Create firm name
function* createFirmNameSaga(action) {
  try {
    const response = yield call(firmNamesAPI.createFirmName, action.payload);
    // API returns { firm_name: { firm object }, message: "..." }
    yield put(actions.createFirmNameSuccess({ data: response.data.firm_name }));
    message.success(response.data.message || 'Firm name created successfully');
    
    // Refresh the list
    yield put(actions.fetchFirmNamesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Failed to create firm name';
    yield put(actions.createFirmNameFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Update firm name
function* updateFirmNameSaga(action) {
  try {
    const { id, firmData } = action.payload;
    const response = yield call(firmNamesAPI.updateFirmName, id, firmData);
    // API returns { firm_name: { firm object }, message: "..." }
    yield put(actions.updateFirmNameSuccess({ data: response.data.firm_name }));
    message.success(response.data.message || 'Firm name updated successfully');
    
    // Refresh the list
    yield put(actions.fetchFirmNamesRequest({}));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Failed to update firm name';
    yield put(actions.updateFirmNameFailure(errorMessage));
    message.error(errorMessage);
  }
}

// Watcher saga
export default function* firmNameSaga() {
  yield takeLatest(types.FETCH_FIRM_NAMES_REQUEST, fetchFirmNamesSaga);
  yield takeLatest(types.FETCH_ACTIVE_FIRM_NAMES_REQUEST, fetchActiveFirmNamesSaga);
  yield takeLatest(types.GET_FIRM_NAME_REQUEST, getFirmNameSaga);
  yield takeLatest(types.CREATE_FIRM_NAME_REQUEST, createFirmNameSaga);
  yield takeLatest(types.UPDATE_FIRM_NAME_REQUEST, updateFirmNameSaga);
}
